import React from "react";
import { PageHeader } from "antd";
import { PercentageOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import TaxRateForm from "./form";

export default function TaxRateCreate() {
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Tax Rates", path: "/billing/tax-rates" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <PercentageOutlined /> }}
        title="Add Tax Rate"
        style={{ marginBottom: 16 }}
      />
      <TaxRateForm />
    </div>
  );
}
